import { Button } from '@/routes/Bookkeeper/components/Button'

export function AppError() {
  return (
    <section className="setup-card">
      <h1>Bookkeeper is unavailable.</h1>
      <p role="alert">We could not open this page. Try again to reload it.</p>
      <Button onClick={() => window.location.reload()}>Try again</Button>
    </section>
  )
}
